import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { TextField, SelectField } from "components/support";

import { debounce } from "util";
import _ from "lodash";

class Filter extends Component {
  state = {
    cnpj: "",
    name: "",
    email: "",
    plan: "all",
    status: "all"
  };

  static status = [
    { value: "all", label: "Todos as empresas" },
    { value: false, label: "Empresas ativas" },
    { value: true, label: "Empresas bloqueadas" }
  ];

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, debounce(() => onFilter(this.state)));
  };

  render() {
    const { cnpj, name, status, plan, email } = this.state;
    const { plans } = this.props;
    const plansNames = [{ value: "all", label: "Todos os planos" }];
    const disableEmail = !!cnpj || !!name || plan !== "all" || status !== "all";

    if (_.isArray(plans)) {
      plans.forEach(plan => {
        plansNames.push({
          value: plan.uuid,
          label: plan.name
        });
      });
    }

    return (
      <Paper elevation={1} className="p-sm mb-md full-width">
        <Typography type="headline">Filtro</Typography>
        <Row between="xs">
          <Col xs={12} sm={6} md>
            <TextField
              disabled={!!email}
              fullWidth
              label="Nome"
              value={name}
              onChange={(_, value) => this.handleField("name", value)}
            />
          </Col>
          <Col xs={12} sm={6} md>
            <TextField
              disabled={!!email}
              fullWidth
              label="CNPJ"
              value={cnpj}
              onChange={(_, value) =>
                this.handleField("cnpj", value.replace(/\D/g, ""))
              }
            />
          </Col>
          <Col xs={12} sm={6} md>
            <TextField
              disabled={disableEmail}
              fullWidth
              label="E-mail do Cliente"
              value={email}
              onChange={(_, value) => this.handleField("email", value)}
            />
          </Col>
          <Col xs={12} sm={6} md>
            <SelectField
              disabled={!!email}
              fullWidth
              label="Plano"
              value={plan}
              onChange={(_, value) => this.handleField("plan", value)}
              options={plansNames}
            />
          </Col>
          <Col xs={12} sm={6} md>
            <SelectField
              disabled={!!email}
              fullWidth
              label="Status da Empresa"
              value={status}
              onChange={(_, value) => this.handleField("status", value)}
              options={Filter.status}
            />
          </Col>
        </Row>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/support/company/filter/index.jsx